import { Card } from '@models/interfaces';
import { BaseComponentConfig } from '@interfaces/config/cms-components/base-config';
import { CmsComponentTypeEnum } from '@models/enums';

export namespace TextMarginal {
  export const TypeEnum = CmsComponentTypeEnum.TEXT_MARGINAL;

  export interface ComponentConfig extends BaseComponentConfig {
    headline: string;
    html: string;
    card: Card.ComponentConfig;
  }
}
